import { render, staticRenderFns } from "./ChipsInput.vue?vue&type=template&id=6b8c05b5&scoped=true"
import script from "./ChipsInput.vue?vue&type=script&lang=js"
export * from "./ChipsInput.vue?vue&type=script&lang=js"
import style0 from "./ChipsInput.vue?vue&type=style&index=0&id=6b8c05b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c05b5",
  null
  
)

export default component.exports